import React, { useEffect } from 'react'
import tekla from '../../../img/Tekla_Logo.png'
import threejs from '../../../img/Three2-js_Logo.png'
import blockchainIcon from '../../../img/blockchain_icon.png'
import { useStore } from '../store'

const data = [
    {
        url: 'https://img.icons8.com/color/48/000000/autodesk-revit.png', alt: 'REVIT ADD-IN', index: 1,
        color: ['#0040FF', '#0D96FF',],
        tech: ['revit', 'c#', 'netCore']
    },
    {
        url: 'https://img.icons8.com/color/48/000000/navisworks.png', alt: 'NAVISWORKS  ADD-IN', index: 2,
        color: ['#3C9D00', '#79FF5B',],
        tech: ['navis', 'c#', 'netCore']
    },
    {
        url: tekla, alt: 'TEKLA STRUCTURE', index: 3,
        color: ['#0099FF', '#F01C1C'],
        tech: ['teklaStructure', 'c#', 'netCore']
    },
    {
        url: 'https://img.icons8.com/external-kmg-design-outline-color-kmg-design/32/000000/external-web-big-data-kmg-design-outline-color-kmg-design.png', alt: 'BIM APP', index: 4,
        color: ['#F8550E', '#FFC800'],
        tech: ['html', 'js', 'css', 'reactjs', 'postgres', 'nodejs', 'mongoDB', 'aF', 'revit', 'trimbleConnect']
    },
    {
        url: 'https://img.icons8.com/external-kmg-design-outline-color-kmg-design/32/000000/external-web-big-data-kmg-design-outline-color-kmg-design.png', alt: 'DIGITAL CHECKLIST', index: 5,
        color: ['#30C5D2', '#471069'],
        tech: ['html', 'js', 'css', 'reactjs', 'postgres', 'c#', 'netCore',]
    }
    ,
    {
        url: threejs, alt: 'THREEJS', index: 6,
        color: ['#494949', '#AEAEAE'],
        tech: ['html', 'js', 'css', 'reactjs', 'nodejs', 'threejs']
    },
    {
        url: blockchainIcon, alt: 'BLOCKCHAIN PROTOTYPE', index: 7,
        color: ['#494949', '#AEAEAE'],
        tech: ['html', 'js', 'css', 'reactjs', 'nodejs', 'avalanche', 'postgres']
    },
    {
        url: blockchainIcon, alt: 'METAVERSE PROTOTYPE', index: 8,
        color: ['#494949', '#AEAEAE'],
        tech: ['html', 'js', 'css', 'reactjs', 'nodejs', 'avalanche', 'threejs', 'postgres']
    }
]
//https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/Progressive_Web_Apps_Logo.svg/1200px-Progressive_Web_Apps_Logo.svg.png
export default function ControlProject() {
    const { setProject, project } = useStore()
    const handleProject = (v) => {
        setProject(v)
    }
    useEffect(() => {
        setProject(data[3])
    }, [])
    return (
        <div style={{ position: 'absolute', bottom: 0, width: '100%' }} >
            <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap' }}>
                {data.map(v =>
                    <div className='bql-project-timeline' style={{ display: 'flex', alignItems: 'center' }} onClick={handleProject.bind(this, v)} >
                        <div className={`bql-project-timeline-item ${v.index === project?.index ? 'active' : ''}`}  >
                            <img width={35} src={v.url} alt={v.alt} />

                        </div>
                        <div className='bql-project-timeline-tail'  ></div>
                    </div>
                )}

            </div>
        </div>
    )
}
